// extracted by mini-css-extract-plugin
export default {"advisor":"styles_advisor__Kr4kI"};